import React from "react";
import CallToAction from "../partials/cta";
import ErrorMessage from "../partials/error";
import SectionTitle from "../../../components/sectionTitle";
import NotificationMessage from "../../../components/notification";
import ProductSavings from "./savings";
import ProductReview from "./review";
import ProductCalculator from "./calculator";
import FieldLabel from "../../../components/label";
import BackdropLoader from "./backdrop";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { withStyles } from "@mui/styles";
import { Box, Typography } from "@mui/material";
import { useStyles } from "../indexFormStyles";
import { BUTTON_EXPLORE_BENEFITS } from "../../../constants";

function ProductSelectionForm({
  classes: {
    calculatorCard,
    container,
    containerInner,
    containerProduct,
    containerButton,
    formGroup,
    main,
    productTitle,
    scrollableContainer,
  },
  backdrop,
  calculatorConfig = null,
  calculatorPopup = false,
  categories,
  errorMessage,
  errors,
  modal,
  handleBack,
  handleProceed,
  handleDownload,
  handleChange,
  handleChangeCheckbox,
  handleChangeChipSelect,
  handleClose,
  handleProductTabChange,
  handleShare,
  handleTabChange,
  iframeSrc,
  isFormSubmitted,
  isInputValid,
  form,
  loading,
  maxADBSumAssured = 3000000,
  minAnnualIcome = 100000,
  onBackClickHandler,
  openCalculator,
  onSubmit,
  productList,
  quotation,
  section,
  selectedProduct,
  selectedProductTab,
  selectedTab,
  toggleCalculatorBISection,
  toggleModal,
  setLoading,
}) {
  return (
    <Box className={main}>
      <form noValidate autoComplete="off" onSubmit={onSubmit}>
        <Box className={containerProduct} pt={0}>
          {categories?.length > 1 && (
            <Box display="flex" justifyContent="center" mt={1}>
              <Tabs
                value={selectedTab}
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                variant="standard"
              >
                {categories.map((category, idx) => (
                  <Tab
                    key={category.cid}
                    label={category.name}
                    value={idx}
                    disabled={category.disabled}
                  />
                ))}
              </Tabs>
            </Box>
          )}

          {section.calculator && (
            <Box mt={3}>
              <Box className={calculatorCard}>
                <Box className={formGroup} pl={3} pr={3}>
                  <Typography variant="caption">
                    {
                      calculatorConfig?.[form?.category]?.properties
                        ?.description
                    }
                  </Typography>
                </Box>
                <Box mt={2}>
                  <CallToAction
                    buttonType={"click"}
                    errorMessage={errorMessage}
                    form={form}
                    isDisabled={false}
                    isFormSubmitted={isFormSubmitted}
                    text={"Proceed with Calculator"}
                    handleClick={() => openCalculator()}
                  />
                </Box>
              </Box>

              <Box mt={3} className={calculatorCard}>
                <Box className={formGroup} pl={3} pr={3}>
                  <Typography variant="caption">
                    Proceed directly to Benefit Illustration.
                  </Typography>
                </Box>
                <Box mt={2}>
                  <CallToAction
                    buttonType={"click"}
                    errorMessage={errorMessage}
                    form={form}
                    isDisabled={false}
                    isFormSubmitted={isFormSubmitted}
                    text={"Proceed to BI"}
                    handleClick={() => toggleCalculatorBISection(false, true)}
                  />
                </Box>
              </Box>
            </Box>
          )}

          {section.bi && (
            <Box>
              {1 === 2 && (
                <Box display="flex" justifyContent="center" m={0} mt={1} mb={0}>
                  <SectionTitle
                    title={
                      selectedTab === 1
                        ? "Secure Your Family's Future"
                        : "Plan Your Investment"
                    }
                    onClickHandler={onBackClickHandler}
                  />
                </Box>
              )}

              {productList?.length > 1 && (
                <Box display="flex" justifyContent="center" mt={0} mb={2}>
                  <Tabs
                    value={selectedProductTab}
                    onChange={handleProductTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="standard"
                  >
                    {productList.map((product) => (
                      <Tab
                        key={product.id}
                        label={product.displayname}
                        value={product.id}
                      />
                    ))}
                  </Tabs>
                </Box>
              )}

              {productList?.length === 1 && (
                <Box mt={2} mb={2} fullwidth={"true"} className={productTitle}>
                  <FieldLabel label={form?.productName ?? ""} />
                </Box>
              )}

              <ProductSavings
                backdrop={backdrop}
                errorMessage={errorMessage}
                handleChange={handleChange}
                handleChangeCheckbox={handleChangeCheckbox}
                handleChangeChipSelect={handleChangeChipSelect}
                isInputValid={isInputValid}
                form={form}
                maxADBSumAssured={maxADBSumAssured}
                minAnnualIcome={minAnnualIcome}
                quotation={quotation}
                selectedProduct={selectedProduct}
              />

              <ErrorMessage errors={errors} modal={modal} />
            </Box>
          )}
        </Box>

        {section.bi && (
          <Box
            className={containerButton}
            justifyContent="center"
            alignContent="center"
          >
            <CallToAction
              buttonType={"submit"}
              errorMessage={errorMessage}
              form={form}
              isDisabled={
                isFormSubmitted ||
                !form.dob ||
                errorMessage.dob ||
                (errorMessage.annualIncome && !isInputValid) ||
                !quotation.maturityTerminalBonus1 ||
                (selectedProduct?.productConfig?.education.length &&
                  selectedProduct?.productConfig?.default_education &&
                  !form.education)
              }
              isFormSubmitted={isFormSubmitted}
              text={BUTTON_EXPLORE_BENEFITS}
              handleClick={() => {}}
            />
          </Box>
        )}

        {quotation?.maturityTerminalBonus1 && (
          <ProductReview
            handleBack={handleBack}
            handleProceed={handleProceed}
            handleDownload={handleDownload}
            handleClose={handleClose}
            handleShare={handleShare}
            isFormSubmitted={isFormSubmitted}
            maxADBSumAssured={maxADBSumAssured}
            modal={modal}
            form={form}
            selectedProduct={selectedProduct}
            quotation={quotation}
          />
        )}

        {calculatorPopup && (
          <ProductCalculator
            calculatorPopup={calculatorPopup}
            handleClose={handleClose}
            iframeSrc={iframeSrc}
            loading={loading}
            setLoading={setLoading}
          />
        )}

        {modal.snackbar && (
          <NotificationMessage
            open={modal.snackbar}
            message={
              form.download === 1
                ? "Benefit Illustration has been downloaded on your device."
                : "Benefit Illustration has been shared with you on your mobile number."
            }
            onClose={() => toggleModal("snackbar", false)}
          />
        )}

        <BackdropLoader backdrop={backdrop} />
      </form>
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(ProductSelectionForm);
